import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SigoVehiculoComponent } from "./components/sigo-vehiculo/sigo-vehiculo.component";
import { SigoTractoDollyCamabajaComponent } from "./components/sigo-tracto-dolly-camabaja/sigo-tracto-dolly-camabaja.component";
import { SigoTractoModularComponent } from "./components/sigo-tracto-modular/sigo-tracto-modular.component";
import { SigoTractoPlataformaComponent } from "./components/sigo-tracto-plataforma/sigo-tracto-plataforma.component";
import { SigoTractoCiguenaComponent } from "./components/sigo-tracto-ciguena/sigo-tracto-ciguena.component";
import { SigoTractoCamabajaComponent } from "./components/sigo-tracto-camabaja/sigo-tracto-camabaja.component";
import { SigoTractoDollyModularSinKinpinComponent } from "./components/sigo-tracto-dolly-modular-snkinpin/sigo-tracto-dolly-modular-snkinpin.component";
import { SigoTractoDollyModularConKinpinComponent } from "./components/sigo-tracto-dolly-modular-cnkinpin/sigo-tracto-dolly-modular-cnkinpin.component";
import { SigoTractoDollyModularComponent } from "./components/sigo-tracto-dolly-modular/sigo-tracto-dolly-modular.component";
import { SigoTractoModularSinKinpinComponent } from "./components/sigo-tracto-modular-snkinpin/sigo-tracto-modular-snkinpin.component";
import { SigoTractoModularConKinpinComponent } from "./components/sigo-tracto-modular-cnkinpin/sigo-tracto-modular-cnkinpin.component";
import { SigoTractoRemolqueComponent } from "./components/sigo-tracto-remolque/sigo-tracto-remolque.component";
import { SigoVehiculo2Component } from "./components/sigo-vehiculo2/sigo-vehiculo2.component";
import { SigoTractoCamionComponent } from "./components/sigo-tracto-camion/sigo-tracto-camion.component";

@NgModule({
  declarations: [
    SigoVehiculoComponent,
    SigoTractoDollyCamabajaComponent,
    SigoTractoModularComponent,
    SigoTractoPlataformaComponent,
    SigoTractoCiguenaComponent,
    SigoTractoCamabajaComponent,
    SigoTractoModularComponent,
    SigoTractoDollyModularSinKinpinComponent,
    SigoTractoDollyModularConKinpinComponent,
    SigoTractoDollyModularComponent,
    SigoTractoModularSinKinpinComponent,
    SigoTractoModularConKinpinComponent,
    SigoTractoRemolqueComponent,
    SigoVehiculo2Component,
    SigoTractoCamionComponent,
  ],
  imports: [CommonModule],
  exports: [
    SigoVehiculoComponent,
    SigoTractoDollyCamabajaComponent,
    SigoTractoModularComponent,
    SigoTractoPlataformaComponent,
    SigoTractoCiguenaComponent,
    SigoTractoCamabajaComponent,
    SigoTractoModularComponent,
    SigoTractoDollyModularSinKinpinComponent,
    SigoTractoDollyModularConKinpinComponent,
    SigoTractoDollyModularComponent,
    SigoTractoModularSinKinpinComponent,
    SigoTractoModularConKinpinComponent,
    SigoTractoRemolqueComponent,
    SigoVehiculo2Component,
    SigoTractoCamionComponent,
  ],
})
export class SigoVehiculoModule {}
